
















































































































	import { Component, Vue} from "vue-property-decorator";
	import TextHeader from "@/components/Common/TextHeader.vue";
	import ContactsTable from '@/components/Contacts/ContactsTable.vue';
	import ContactsGallery from "@/components/Contacts/ContactsGallery.vue";
    import IconPdf from '@/components/Icons/IconPdfSmall.vue';
	@Component({
		components: {
		    TextHeader,
            ContactsTable,
            ContactsGallery,
            IconPdf,
		}
	})
	export default class ContactsPage extends Vue{
        navigateJobs(job: string){
            this.$router.push({name: "PageViewer", params: {identifier: "job"}, hash: `#${job}`});
		}
	}
